import type { Dispatch, SetStateAction } from "react";
import {
  EDIT_CONFIGURATION_EDITOR_MODE,
  VIEW_CONFIGURATION_EDITOR_MODE,
} from "../../../../constants/stringLiterals";
import { GiConfigurationForAddNewViewTab } from "../../../../data-model/giConfigDetails";
import type { GiConfiguration } from "../../../../pages/configurations/pages/giRpaConfiguration/hooks/useGiConfiguration";

interface SelectOption {
  value: string;
  label: string;
}

export type JsonEditorMode =
  | typeof VIEW_CONFIGURATION_EDITOR_MODE
  | typeof EDIT_CONFIGURATION_EDITOR_MODE;

interface HandleSelectConfigurationParams {
  option: SelectOption;
  giConfigurations: GiConfiguration[] | null;
  setJsonEditorMode: Dispatch<SetStateAction<JsonEditorMode>>;
  setGiConfiguration: Dispatch<SetStateAction<GiConfigurationForAddNewViewTab>>;
  setConfigText: Dispatch<SetStateAction<string>>;
  setConfigError: Dispatch<SetStateAction<string | null>>;
  viewMode: JsonEditorMode;
}

/**
 * Handles selecting a GI configuration in the Add New View Tab modal.
 * Updates editor mode, selected config metadata, and the editable JSON text,
 * and clears any existing JSON validation error.
 */
export const handleSelectConfiguration = ({
  option,
  giConfigurations,
  setJsonEditorMode,
  setGiConfiguration,
  setConfigText,
  setConfigError,
  viewMode,
}: HandleSelectConfigurationParams) => {
  const selectedConfig = giConfigurations?.find(
    (giConfiguration) => giConfiguration.id === option.value,
  );

  setJsonEditorMode(viewMode);
  setGiConfiguration((prev) => ({
    ...prev,
    id: selectedConfig?.id || "",
    view_tab: selectedConfig?.view_tab || "",
    num_orders: selectedConfig?.num_orders || 0,
    config: selectedConfig?.config || {},
  }));
  setConfigText(JSON.stringify(selectedConfig?.config ?? {}, null, 2));
  setConfigError(null);
};
